import { combineEpics } from "redux-observable";
import loginWithGhinEpic from "./login";

export default combineEpics(loginWithGhinEpic);
